import { CreateTaskDto } from '../dtos/CreateTaskDto';
import { TaskSchema } from '../schemas';
import { isBlank, isPlainObject, parseJson, toStringRecord } from '../utils';

const parseHeaders = (headersText: string): Record<string, string> => {
  if (isBlank(headersText)) return {};
  const parsed = parseJson(headersText);
  if (!parsed.ok || !isPlainObject(parsed.value)) return {};
  return toStringRecord(parsed.value);
};

const parseBody = (bodyText: string): unknown => {
  if (isBlank(bodyText)) return undefined;
  const parsed = parseJson(bodyText);
  return parsed.ok ? parsed.value : undefined;
};

/**
 * El formulario edita headers y body como texto JSON; el back los espera ya
 * parseados (`data` se envía como body en POST/PUT/DELETE y como query en GET).
 */
export const mapTaskFormToCreateTaskDto = (form: TaskSchema): CreateTaskDto => ({
  name: form.name.trim(),
  cronExpression: form.cronExpression.trim(),
  url: form.url.trim(),
  method: form.method,
  headers: parseHeaders(form.headersText),
  data: parseBody(form.bodyText),
  authRequired: form.authRequired,
  status: form.status,
});
